import { render, staticRenderFns } from "./testMessages.vue?vue&type=template&id=6c19a770&scoped=true"
import script from "./testMessages.vue?vue&type=script&lang=js"
export * from "./testMessages.vue?vue&type=script&lang=js"
import style0 from "./testMessages.vue?vue&type=style&index=0&id=6c19a770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19a770",
  null
  
)

export default component.exports